import { IModalAction, IModalActions, IModalState } from './model';

const OPEN_OPTIONS_MODAL = 'OPEN_OPTIONS_MODAL';
const CLOSE_OPTIONS_MODAL = 'CLOSE_OPTIONS_MODAL';

const initialState: IModalState = {
  optionsModal: {
    opened: false,
    data: null
  }
};

export const reducer = (state: IModalState = initialState, action: IModalAction) => {
  switch (action.type) {
    case OPEN_OPTIONS_MODAL:
      return {
        ...state,
        optionsModal: {
          ...state.optionsModal,
          opened: true,
          data: action.payload,
        }
      };
    case CLOSE_OPTIONS_MODAL:
      return {
        ...state,
        optionsModal: {
          ...state.optionsModal,
          opened: false,
          data: null,
        }
      };
    default:
      return state;
  }
};

const openOptionsModal = (data: any): IModalAction => ({ type: OPEN_OPTIONS_MODAL, payload: data });
const closeOptionsModal = (): IModalAction => ({ type: CLOSE_OPTIONS_MODAL, payload: null });

export const actions: IModalActions = {
  openOptionsModal,
  closeOptionsModal,
};
